import { getUrlPathParams, encodeURIPart, getCatalogPathFromUrl } from './url';
import isEqual from 'lodash/isEqual';

function getCatalogUrlParams(url) {
  const params = getUrlPathParams(url, [
    'catalog',
    'section',
    'category',
    'subcategory',
  ]);
  return params;
}

const preferedSlugOrder = [
  'section',
  'category',
  'subcategory',
  'query',
  'brands',
  'stores',
  'labels',
  'certificates',
  'materials',
  'size',
  'colors',
  'sale',
  'giftcard',
  'locations',
  'page',
];

const refimentLists = [
  { name: 'brand_name', slug: 'brands' },
  { name: 'label_ids', slug: 'labels' },
  { name: 'color', slug: 'colors' },
  { name: 'store_name', slug: 'stores' },
  { name: 'certificate_names', slug: 'certificates' },
  { name: 'size_labels', slug: 'size' },
  { name: 'material_ids', slug: 'materials' },
  { name: 'store_location', slug: 'locations' },
  { name: 'section_names', slug: 'section' },
];

// - Data to go from ID to translated data (such as name, urlpath, slug, subcats, main_cat)
// - Data to go from translated path to ID (+ above category ID if subcategory )
// - Data to go from hierarchical Menu path (combined IDs) to translated data (e.g. in router, and display)

export function createRouter({ context, router, store, indexName }) {
  // nextRouter is null when there is no vue-router page switch happening
  // it's only defined while a page switch is happening, see the
  // router.beforeEach and router.afterEach methods lower in this module
  let nextRoute = null;
  let isPushing = null;
  let isInitial = true;

  /**
   *
   * @param {Object} hierarchicalMenu
   * @returns Object
   */
  function parseHierarchicalMenu(hierarchicalMenu = {}) {
    let sectionSlug;
    let categorySlug;
    let subcategorySlug;
    let section;
    let category;
    let subcategory;
    const hierarchicalMenuKeys = Object.keys(hierarchicalMenu);
    if (hierarchicalMenu && hierarchicalMenuKeys.length > 0) {
      section = hierarchicalMenuKeys[0].split('_')[0];

      sectionSlug = store.state.categories[section].slug;

      if (hierarchicalMenu[`${section}_categories.lvl0`]) {
        category = hierarchicalMenu[`${section}_categories.lvl0`][0];

        categorySlug = store.state.categories[section].c[category].slug;

        if (hierarchicalMenu[`${section}_categories.lvl0`].length > 1) {
          subcategory = hierarchicalMenu[`${section}_categories.lvl0`][1];

          subcategorySlug =
            store.state.categories[section].c[category].s[subcategory].slug;
        }
      }
    }
    // console.log('parseHierarchicalMenu', { sectionSlug, categorySlug, subcategorySlug });

    return {
      sectionSlug,
      categorySlug,
      subcategorySlug,
      section,
      category,
      subcategory,
    };
  }

  /**
   * Generate Algolia instant-search route state based on url
   * @param {Object} options
   * @returns
   */
  function read({ store, url }) {
    let routeState = {
      [indexName]: {
        refinementList: {},
        toggle: {},
        range: {},
      },
    };

    // Using http://example.org because URL is expecting a full url
    // as we only want the query parameters it doesn't matter what the hostname is
    const queryParameters = new URL('http://example.org' + url).searchParams;

    // const queryString = url.slice(url.indexOf('?'));
    // const queryParameters = qs.parse(queryString, {
    // ignoreQueryPrefix: true,
    // });

    // Convert refinement lists
    refimentLists.forEach(refinement => {
      if (queryParameters.has(refinement.slug)) {
        routeState[indexName].refinementList[refinement.name] = queryParameters
          .get(refinement.slug)
          .split(',')
          .map(part => decodeURIComponent(part));
      }
    });

    // Convert others
    if (queryParameters.has('sale')) {
      routeState[indexName].toggle.discounted = queryParameters.get('sale');
    }
    if (queryParameters.has('giftcard')) {
      routeState[indexName].toggle.fair_fashion_giftcard =
        queryParameters.get('giftcard');
    }
    if (queryParameters.has('price')) {
      routeState[indexName].range[
        `currency_prices.${store.state.currency}.price`
      ] = queryParameters.get('price');
    }
    if (queryParameters.has('query')) {
      routeState[indexName].query = decodeURIComponent(
        queryParameters.get('query')
      );
    }
    if (queryParameters.has('page')) {
      routeState[indexName].page = queryParameters.get('page');
    }
    if (queryParameters.has('sortBy')) {
      routeState[indexName].sortBy = `${indexName}/sort/${decodeURIComponent(
        queryParameters.get('sortBy')
      ).replace('-', ':')}`;
    }

    // Handle section, category and subcategory query parameters
    // (for search, brand and store page)
    if (queryParameters.has('section') && queryParameters.has('category')) {
      // Get section id based on section slug
      const section =
        store.getters.sectionSlugToIdMap[queryParameters.get('section')];

      // Get category id based on section slug
      const category = queryParameters.get('category');
      // const category = store.getters.categorySlugToIdMap(section)[queryParameters.get('category')];
      // Set category id filter
      routeState[indexName].hierarchicalMenu = {
        [`${section}_categories.lvl0`]: [category],
      };

      if (queryParameters.has('subcategory')) {
        // If there is a subcategory, set subcategory filter by subcategory id
        routeState[indexName].hierarchicalMenu[
          `${section}_categories.lvl0`
        ].push(
          // store.getters.subcategorySlugToIdMap(section, category)[
          queryParameters.get('subcategory')
          // ]
        );
      }
    }

    // Figure out category and subcategory based on url
    const urlParams = getCatalogUrlParams(url);
    console.log(urlParams);
    if (!urlParams) {
      console.error(`Not able to match url '${url}' to url pattern`);
      return routeState;
    }

    const catalogPath = getCatalogPathFromUrl(url);
    console.log(catalogPath);

    const section = store.getters.sectionSlugToIdMap[urlParams.section];
    // if (
    //   ['women', 'men', 'kids', 'home', 'beauty-care'].includes(
    //     section
    //   )
    // )

    if (
      !['search', 'store', 'brand', 'fair-fashion-alternatives'].includes(
        urlParams.section
      )
    ) {
      const categoryFilter = [];
      if (urlParams.category === 'all') {
        // If the visitor is on the /catalog/<section>/all url, add section as a refinement
        routeState[indexName].refinementList.section_names = [section];
      } else {
        //categoryFilter is set based on the (sub)category retrieved
        // from the url path instead of IDs parsed from the url.
        // So we are able to get the subcategory and category ID from the url paths.
        if (urlParams.subcategory) {
          let categoryIds =
            store.getters.subcategorySlugToIdMap(section)[catalogPath];
          console.log('categoryIds', categoryIds);

          // If the visitor is on the /catalog/<section>/<category>/<subcategory>
          categoryFilter.push(categoryIds['categoryId']);
          categoryFilter.push(categoryIds['subcategoryId']);
        } else {
          // If the visitor is on the /catalog/<section>/<category> url
          // Otherwise add a category filter to the hierarchicalMenu widget
          categoryFilter.push(
            store.getters.categorySlugToIdMap(section)[catalogPath]
          );
        }
      }

      // if (urlParams.subcategory) {
      //   categoryFilter.push(
      //     store.getters.subcategorySlugToIdMap(section, categoryFilter[0])[
      //      urlParams.subcategory
      //     ]
      //   );
      // }

      // Pass category and subcategory to Algolia route state
      if (categoryFilter.length > 0) {
        routeState[indexName].hierarchicalMenu = {
          [`${section}_categories.lvl0`]: categoryFilter,
        };
      }
    }

    return routeState;
  }

  /**
   * Generate url based on Algolia instant-search route state
   * @param {Object} options
   * @returns
   */
  function createURL({ store: vuex, routeState }) {
    // Get category and subcategory slugs based on category and subcategory
    // given in route state. Once found keep the slug, but remove the entries
    // from the route state so that they are not also serialized into the
    // query parameters
    let {
      sectionSlug,
      categorySlug,
      subcategorySlug,
      section,
      category,
      subcategory,
    } = parseHierarchicalMenu(routeState[indexName].hierarchicalMenu);

    const queryParameters = {};

    // Convert refinements
    if (routeState[indexName].refinementList) {
      refimentLists.forEach(refinement => {
        if (routeState[indexName].refinementList[refinement.name]) {
          queryParameters[refinement.slug] = routeState[
            indexName
          ].refinementList[refinement.name]
            .map(part => encodeURIPart(part))
            .join(',');
        }
      });
    }

    // Convert toggles
    if (routeState[indexName].toggle) {
      if (routeState[indexName].toggle.discounted) {
        queryParameters.sale = routeState[indexName].toggle.discounted;
      }
      if (routeState[indexName].toggle.fair_fashion_giftcard) {
        queryParameters.giftcard =
          routeState[indexName].toggle.fair_fashion_giftcard;
      }
    }

    // Convert ranges
    if (routeState[indexName].range) {
      if (
        routeState[indexName].range[
          `currency_prices.${vuex.state.currency}.price`
        ]
      ) {
        queryParameters.price =
          routeState[indexName].range[
            `currency_prices.${vuex.state.currency}.price`
          ];
      }
    }

    // Convert other
    if (routeState[indexName].query) {
      queryParameters.query = encodeURIPart(routeState[indexName].query);
    }
    if (routeState[indexName].page) {
      queryParameters.page = routeState[indexName].page;
    }
    if (
      routeState[indexName].sortBy &&
      routeState[indexName].sortBy !== indexName
    ) {
      queryParameters.sortBy = encodeURIPart(
        routeState[indexName].sortBy
          .replace(`${indexName}/sort/`, '')
          .replace(':', '-')
      );
    }

    // Temporarily: should be removed when a decision has been
    // made about the productview shadows
    if (router.currentRoute.query.disableShadows) {
      queryParameters.disableShadows = router.currentRoute.query.disableShadows;
    }

    // Keep all url parameters on first page load (for referral tracking).
    // After that, the urls no longer need it.
    if (isInitial === true) {
      // Iterate over all query parameters
      for (const [key, value] of Object.entries(router.currentRoute.query)) {
        // Check if the key is not in the preferedSlugOrder list
        if (!preferedSlugOrder.includes(key)) {
          // Add it to the queryParameters object
          queryParameters[key] = value;
        }
      }
      isInitial = false;
    }

    let result = '';

    const urlParams = getCatalogUrlParams(router.currentRoute.fullPath);
    let hasLocale = false;
    const locale = router.currentRoute.fullPath.split('/')[1];
    if (locale.length === 2) {
      hasLocale = true;
    }

    // If we are currently on a search, store or brand page
    // the generated url should be handeled differently (section,
    // section, category and subcategory go in the query params for example,
    // instead of as url params)
    if (
      urlParams &&
      ['search', 'store', 'brand', 'fair-fashion-alternatives'].includes(
        urlParams.section
      )
    ) {
      section = section || queryParameters.section;
      result = `${hasLocale ? '/' + locale : ''}/catalog/search/`;

      if (urlParams.section == 'store' && urlParams.category) {
        // Handle store urls
        let store = urlParams.category;
        if (
          store.toLowerCase() !== vuex.state.catalog.store.slug.toLowerCase()
        ) {
          console.error(
            `Store slug from url is not same as store given by catalog context api ${store} vs. ${vuex.state.catalog.store.slug}`
          );
        }
        result = `${hasLocale ? '/' + locale : ''}/catalog/store/${
          vuex.state.catalog.store.slug
        }/`;
      } else if (urlParams.section == 'brand' && urlParams.category) {
        // Handle brand urls
        let brand = urlParams.category;
        if (
          brand.toLowerCase() !== vuex.state.catalog.brand.slug.toLowerCase()
        ) {
          console.error(
            `Brand from refinement is not same as brand given by catalog context api ${brand} vs. ${vuex.state.catalog.brand.slug}`
          );
        }
        result = `${hasLocale ? '/' + locale : ''}/catalog/brand/${
          vuex.state.catalog.brand.slug
        }/`;
      } else if (urlParams.section === 'fair-fashion-alternatives') {
        result = `${
          hasLocale ? '/' + locale : ''
        }/catalog/fair-fashion-alternatives/image-search/`;
      }

      // queryParameters.category = category ? encodeURIPart(category) : null;
      // queryParameters.subcategory = subcategory
      //   ? encodeURIPart(subcategory)
      //   : null;
      queryParameters.section = section ? encodeURIComponent(section) : null;
      queryParameters.category = category ? encodeURIComponent(category) : null;
      queryParameters.subcategory = subcategory
        ? encodeURIComponent(subcategory)
        : null;
    } else {
      // Otherwise we generated a normal catalog url
      // with section, category and subcategory in the
      // url itself instead of as query params
      result = `${hasLocale ? '/' + locale : ''}/catalog/`;

      if (subcategorySlug) {
        result += `${subcategorySlug}/`;
      } else if (categorySlug) {
        result += `${categorySlug}/`;
      } else {
        result += `${sectionSlug || urlParams.section}/all/`;
        console.log('all: ', urlParams.section, sectionSlug, section);
      }

      // result = `${hasLocale ? '/' + locale : ''}/catalog/${
      //   sectionSlug || urlParams.section
      // }/`;
      // if (categorySlug) {
      //   result += `${categorySlug}/`;
      // } else {
      //   result += 'all/';
      // }
      // if (subcategorySlug) {
      //   result += `${subcategorySlug}/`;
      // }
      // Also delete section query paramter, as the section is already
      // in the url itself
      delete queryParameters.section;
    }

    // Convert query parameters object to query string
    // filter out empty values
    // sort based on prefered order
    const filteredQueryKeys = Object.keys(queryParameters).filter(
      param => !!queryParameters[param]
    );
    if (filteredQueryKeys.length > 0) {
      result += `?${filteredQueryKeys
        .sort(
          (paramA, paramB) =>
            preferedSlugOrder.indexOf(paramA) -
            preferedSlugOrder.indexOf(paramB)
        )
        .map(param => `${param}=${queryParameters[param]}`)
        .join('&')}`;
    }

    return result;
  }

  return {
    read(_url) {
      // If we're still on the initial route, work with the url passed by Django
      // when we left the initial route work with the route url as vue-router knows it
      const url =
        _url ||
        (router.currentRoute.fullPath === '/'
          ? context.url
          : router.currentRoute.fullPath);
      return read({ store, url });
    },
    write(routeState) {
      const url = this.createURL(routeState);
      const currentRouteState = this.read();

      // Remove the sortBy key from the routeState if it is undefined, otherwise the
      // deep equal comparison below won't work
      if (routeState[indexName].sortBy === undefined) {
        delete routeState[indexName].sortBy;
      }

      if (
        // If there is a nextRoute it means we are currently transitioning to a
        // new page. For that reason it makes sense that algolia received a state
        // update and is trying to also update the url. A url update is what triggered
        // the state update though, so no reason to update the URL again
        (!nextRoute || nextRoute.fullPath !== url) &&
        // If the new url is the same as the current url, no need to tell vue-router
        // about it, probably vue-router initiated it
        router.currentRoute.fullPath !== url &&
        // Make sure the new route state won't end up being the same
        // as the current one
        !isEqual(currentRouteState, routeState) &&
        // Only update vue-router client-side
        typeof history === 'object'
      ) {
        isPushing = url;
        router.push(url).catch(err => {
          if (err.message.startsWith('Avoided redundant navigation')) {
            // Try to catch redundant navigation errors and log extra information to
            // figure out what goes wrong
            console.error(
              `${err.message} current: ${router.currentRoute.fullPath}; new: ${url}`
            );
          } else {
            console.error(err);
          }
        });
      }
    },
    createURL(routeState) {
      const url =
        context && context.url
          ? context.url
          : typeof window.location === 'object'
          ? window.location.href
          : '';

      return createURL({ store, routeState, url });
    },
    onUpdate(callback) {
      router.beforeEach((to, from, next) => {
        // The route update that's happening has been initiate by the .write method above.
        // This means we don't have to update aloglia with this change again, as Algolia is
        // the one who told us to update in the first place
        if (isPushing == to.fullPath) {
          next();
          return;
        }
        // Track what the next route is going to be, because Algolia
        // might inbetween also try to navigate to a new url because
        // it receives a new state from it's backend. Probably this
        // new state is the same as the url we're navigating to, because
        // that's the reason it was going to fetch this new state in the first
        // place. In that case we want to prevent a router.push here in routing.write
        nextRoute = to;
        // When the router gets an update, also
        // tell Algolia Instantsearch of this new url
        callback(this.read(to.fullPath));
        next();
      });
      router.afterEach(() => {
        // Reset the nextRoute as a new navigation is allowed to happen from now on
        nextRoute = null;
        isPushing = null;
      });
    },
    dispose() {
      // No event listeners to dispose
    },
  };
}
